import { render, staticRenderFns } from "./UserIdentification.vue?vue&type=template&id=500513f2"
import script from "./UserIdentification.vue?vue&type=script&lang=js"
export * from "./UserIdentification.vue?vue&type=script&lang=js"
import style0 from "./UserIdentification.vue?vue&type=style&index=0&id=500513f2&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('500513f2')) {
      api.createRecord('500513f2', component.options)
    } else {
      api.reload('500513f2', component.options)
    }
    module.hot.accept("./UserIdentification.vue?vue&type=template&id=500513f2", function () {
      api.rerender('500513f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/User/UserIdentification.vue"
export default component.exports